"use strict";
/* tslint:disable */
var TLoyaltyPointsPresenter = (function () {
    function buildLoyaltyPointsInReceipt(placedBet, isEachWayBet) {
        var loyaltyPoints = BetSlipUtil.getLoyaltyPoints(placedBet, isEachWayBet);
        if (!loyaltyPoints) {
            return '';
        }
        var lp1Rules = loyaltyPoints.LoyaltyPointType1;
        var lp2Rules = loyaltyPoints.LoyaltyPointType2;
        var lp3Rules = loyaltyPoints.LoyaltyPointType3;
        if (lp1Rules === 0 && lp2Rules === 0 && lp3Rules === 0) {
            return '';
        }
        var betID = placedBet.BetID;
        var __html = '';
        __html += `
            <div><strong>${$dict.bs("LoyaltyPointsTitle")}</strong></div>
            <div id="loyaltyPoints" class="loyalty-points">`;
        if (lp2Rules) {
            __html += `
                    <div class="loyalty-points-type loyalty-points-type-2">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-2"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-2-label">${$dict.bs("LP2")}</span>
                        <span id="PointType2Rules-${betID}" class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-2-value">${PointsFormat.format(lp2Rules)}</span>
                    </div>`;
        }
        if (lp1Rules) {
            __html += `
                    <div class="loyalty-points-type loyalty-points-type-1">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-1"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-1-label">${$dict.bs("LP1")}</span>
                        <span id="PointType1Rules-${betID}" class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-1-value">${PointsFormat.format(lp1Rules)}</span>
                    </div>`;
        }
        if (lp3Rules) {
            __html += `
                    <div class="loyalty-points-type loyalty-points-type-3">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-3"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-3-label">${$dict.bs("LP3")}</span>
                        <span id="PointType3Rules-${betID}" class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-3-value">${PointsFormat.format(lp3Rules)}</span>
                    </div>`;
        }
        __html += `
            </div>`;
        return __html;
    }
    function buildMyBetsView(bet) {
        var loyaltyPoints = LoyaltyProgramCalculations.calculateLoyaltyPointsInOpenBets(bet);
        var __html = '';
        if (loyaltyPoints.LoyaltyPointType1 || loyaltyPoints.LoyaltyPointType2 || loyaltyPoints.LoyaltyPointType3) {
            __html += `
            <div class="loyalty-points">
                <div class="loyalty-points-title">${$string("UserInfo").PotentialPoints}</div>`;
            if (loyaltyPoints.LoyaltyPointType2) {
                __html += `
                    <div class="loyalty-points-type loyalty-points-type-2">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-2"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-2-label">${$string("UserInfo").LoyaltyPointType2}</span>
                        <span class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-2-value">${PointsFormat.format(loyaltyPoints.LoyaltyPointType2)}</span>
                    </div>`;
            }
            if (loyaltyPoints.LoyaltyPointType1) {
                __html += `
                    <div class="loyalty-points-type loyalty-points-type-1">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-1"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-1-label">${$string("UserInfo").LoyaltyPointType1}</span>
                        <span class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-1-value">${PointsFormat.format(loyaltyPoints.LoyaltyPointType1)}</span>
                    </div>`;
            }
            if (loyaltyPoints.LoyaltyPointType3) {
                __html += `
                    <div class="loyalty-points-type loyalty-points-type-3">
                        <span class="icon i-16 i-c-betslip-loyalty-pt-3"></span>
                        <span class="loyalty-points-text loyalty-points-text-name" data-uat="lpts-type-3-label">${$string("UserInfo").LoyaltyPointType3}</span>
                        <span class="loyalty-points-text loyalty-points-text-count" data-uat="lpts-type-3-value">${PointsFormat.format(loyaltyPoints.LoyaltyPointType3)}</span>
                    </div>`;
            }
            __html += `
            </div>`;
        }
        return __html;
    }
    return {
        buildLoyaltyPointsInReceipt: buildLoyaltyPointsInReceipt,
        buildMyBetsView: buildMyBetsView
    };
}());
window.TLoyaltyPointsPresenter = TLoyaltyPointsPresenter;
//# sourceMappingURL=TLoyaltyPointsPresenter.js.map